import download from "downloadjs";

export default (response) => {
  let contentType = response.headers["content-type"];
  let fileName = "file";

  // Try to get file name from response headers
  if (response.headers["content-disposition"]) {
    fileName = response.headers["content-disposition"].split("=").pop() ?? "file";

    // File name should be decoded
    if (fileName.includes("utf-8''")) {
      fileName = decodeURIComponent(fileName.replace("utf-8''", ""));
    }

    // Remove quotes from filename if present
    fileName = fileName.replace(/^["']|["']$/g, "");
  }

  // Map content type to file extension
  let extensionMap = {
    "application/pdf": ".pdf",
    "image/jpeg": ".jpg",
    "image/png": ".png",
    "application/zip": ".zip",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ".docx",
    "application/vnd.ms-excel": ".xls",
    "text/csv": ".csv",
  };

  // Clean file name - remove everything after valid extension including underscores
  const extensionPattern = /\.(pdf|docx|xlsx|xls|csv|zip|jpg|jpeg|png)(_.*)?$/i;
  const match = fileName.match(extensionPattern);

  if (match) {
    // Keep only the part before the extension + the extension itself
    const extensionIndex = fileName.indexOf(match[1] ? match[0].replace(match[1], "") : match[0]);
    const extension = match[0].split("_")[0];
    fileName = fileName.substring(0, extensionIndex) + extension;
  }

  // Check if file name has extension
  if (!/\.[a-zA-Z]{3,}$/.test(fileName)) {
    let extension = extensionMap[contentType] || "";
    fileName += extension;
  }

  download(response.data, fileName, contentType);
};
